import {AngularFirestore} from '@angular/fire/firestore';
import {FullUser, Image} from '../model';
import {from, Observable, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {AngularFireStorage} from '@angular/fire/storage';
import {UploadTaskSnapshot} from '@angular/fire/storage/interfaces';
import {AuthService} from '../../authentication/auth.service';
import {UserToEdit} from '../state/users.reducer';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';


export interface UserRecord {
  id: string;
  path: string;

}
@Injectable({providedIn: 'root'})
export class  UserService {

  public previewUser: FullUser;
  constructor(private fireStore: AngularFirestore,
              private storage: AngularFireStorage,
              private authService: AuthService) {}

  public saveUser(user: FullUser): Observable<FullUser> {
    console.log('user sent to save is ', user);
    return from(this.fireStore.collection(this.userPath(user.displayName)).doc(user.displayName).set(user)).pipe(
        switchMap(() => this.authService.updateDisplayName(user.displayName)),
      switchMap(() => of(user)));
  }

  private userPath(displayName: string): string {
    return `/users/`;
  }

  fetchUser(displayName: string): Observable<FullUser> {
    return this.fireStore.collection(this.userPath(displayName)).doc<FullUser>(displayName)
      .get().pipe(
        switchMap((doc: firebase.firestore.DocumentSnapshot) => {
          if (doc.exists) {
            return  of(doc.data() as FullUser);
          } else {
            return of({displayName});
          }
        })
      );
  }

  saveBannerImage(username: string, file: File): Observable<Image> {
    if ( ! file ) {
      return of(null);
    }
    return this.upload(username, 'banner', file);
  }

  saveUserImage(username: string, file: File): Observable<Image> {
    if ( ! file ) {
      return of(null);
    }
    return this.upload(username, 'profile', file).pipe(
    switchMap((img) => this.authService.user.pipe(
      switchMap(user => from(user.updateProfile({photoURL: img.url})
        .then(() => console.log('user profile updated'))
        .catch(error => console.log('error updating profile', error)))),
      map(() => img))
    ));
  }

  private upload(username: string, path: string, file: File): Observable<Image> {
    const filepath = `/users/${username}/${path}/${file.name}`;
    const upload = this.storage.upload(filepath, file);
    return from(
      upload.task
        .then((onFulfilled: UploadTaskSnapshot) =>  onFulfilled.ref.getDownloadURL())
        .then(url => {
          return {url, path: filepath};
          }
          ));
  }

  public saveUserToEdit(user: UserToEdit): Observable<FullUser> {
    const {newBannerImageUrl, newBannerImageFile, newImages, ...newUser } = user;
    console.log('created user is ', newUser);
    if (!newUser.images) { newUser.images = []; }
    if (!newUser.youtubes) { newUser.youtubes = []; }

    return this.saveImages(newUser, user.newImages).pipe(
      switchMap( () => {
        if ( user.newBannerImageFile !== null) {
          return this.saveBannerImage(user.displayName, user.newBannerImageFile);
        } else {
          return of(user.bannerImage !== undefined ? user.bannerImage : {url: '', path: ''});
        }
      }),
      map(bannerImage => newUser.bannerImage = bannerImage),
      switchMap( () => this.saveUser(newUser)
      )
    );
  }

  private saveImages(user: FullUser, newImages: Array<{src: string| ArrayBuffer, file: File}>,
                     ): Observable<any> {
    // we need at least one observable ot the rest of the pipeline won't fire
    const tasks$ = [];
    tasks$.push(of(''));
    user.images.filter(src => !newImages.map(s => s.src).includes(src.url))
      .map(src => {
          tasks$.push(this.storage.ref(src.path).delete().pipe(
            map(() => {
              return user.images = user.images.filter(img => img.path !== src.path);
            })));
        }
      );
    newImages.filter(img =>  img.file !== null)
      .map((obj: {src, file: File }) => {
        tasks$.push(this.upload(user.displayName, `images/`, obj.file).pipe(
          map(img => user.images.push(img))
        ));
      });
    return forkJoin(tasks$);
  }
}
